<template>
  <product-infowrap :product="product" :fields="fields" :title="_('Connections and services')" :baseDomain="baseDomain" :shopId="shopId"></product-infowrap>
</template>

<script>
import ProductInfowrap from '~/components/ProductInfowrap.vue'

export default {
  data () {
    return {
      fields: ['serviceinformation', 'trafficconnections', 'drivinginstructions', 'hideImage']
    }
  },
  props: ['product', 'baseDomain', 'shopId'],
  components: {
    ProductInfowrap
  }
}
</script>
